import React from 'react';
import { Check, Lock } from 'lucide-react';
interface PricingGridProps {
  selectedPack: number;
  setSelectedPack: (pack: number) => void;
  packLinks: string[];
}
export function PricingGrid({
  selectedPack,
  setSelectedPack,
  packLinks
}: PricingGridProps) {
  return <div data-id="element-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-5" data-id="element-5">
        {/* Pack 0: Pack Completo */}
        <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer ${selectedPack === 0 ? 'bg-[#111633] border-2 border-[#eab308] shadow-[0_0_15px_rgba(234,179,8,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-6">
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#eab308] bg-[#eab308]' : 'border-gray-600'}`} data-id="element-7">
            {selectedPack === 0 && <Check className="w-2 h-2 md:w-2.5 md:h-2.5 text-black font-bold" data-id="element-8" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-9">📦</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-10">
            KIT COMPLETO DE HISTORIA
          </h3>
          <p className="text-[10px] md:text-xs text-gray-400 mb-1.5 font-medium" data-id="element-11">
            Para Docentes de Secundaria Argentina — Edición 2026
          </p>
          <ul className="space-y-0.5 mb-1.5" data-id="element-12">
            <li className="flex items-start gap-1 text-gray-300 text-[9px] md:text-[11px] leading-tight font-medium" data-id="element-13">
              <Check className="w-2.5 h-2.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-14" />
              6 Tomos
            </li>
            <li className="flex items-start gap-1 text-gray-300 text-[9px] md:text-[11px] leading-tight font-medium" data-id="element-15">
              <Check className="w-2.5 h-2.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-16" />
              4 Bonus
            </li>
            <li className="flex items-start gap-1 text-gray-300 text-[9px] md:text-[11px] leading-tight font-medium" data-id="element-17">
              <Check className="w-2.5 h-2.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-18" />
              Acceso Inmediato
            </li>
          </ul>
          <div className="flex items-baseline gap-1" data-id="element-19">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-20">
              $19.990
            </span>
          </div>
          <span className="text-gray-500 text-[10px] line-through font-bold" data-id="element-21">
            $39.990
          </span>
        </button>

        {/* Pack 1: Pack Completo + Proyectos */}
        <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer ${selectedPack === 1 ? 'bg-[#111633] border-2 border-[#eab308] shadow-[0_0_15px_rgba(234,179,8,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-22">
          <span className="absolute -top-2 left-1/2 -translate-x-1/2 bg-[#eab308] text-black text-[8px] md:text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap shadow-md" data-id="element-23">
            ⭐ Más elegido
          </span>
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#eab308] bg-[#eab308]' : 'border-gray-600'}`} data-id="element-24">
            {selectedPack === 1 && <Check className="w-2 h-2 md:w-2.5 md:h-2.5 text-black font-bold" data-id="element-25" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-26">🚀</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-27">
            Pack Completo
          </h3>
          <p className="text-[10px] md:text-xs text-[#eab308] mb-1.5 font-bold" data-id="element-28">
            KIT COMPLETO + SISTEMA DE PROYECTOS HISTÓRICOS
          </p>
          <ul className="space-y-0.5 mb-1.5" data-id="element-29">
            <li className="flex items-start gap-1 text-gray-300 text-[9px] md:text-[11px] leading-tight font-medium" data-id="element-30">
              <Check className="w-2.5 h-2.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-31" />
              6 Tomos + 4 Bonus
            </li>
            <li className="flex items-start gap-1 text-gray-300 text-[9px] md:text-[11px] leading-tight font-medium" data-id="element-32">
              <Check className="w-2.5 h-2.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-33" />
              Sistema avanzado para trabajar proyectos históricos en el aula
            </li>
          </ul>
          <div className="flex items-baseline gap-1" data-id="element-34">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-35">
              $27.990
            </span>
          </div>
          <span className="text-gray-500 text-[10px] line-through font-bold" data-id="element-36">
            $49.990
          </span>
        </button>
      </div>

      {/* CTA Button */}
      <div className="text-center mb-3 md:mb-4" data-id="element-37">
        <a href={packLinks[selectedPack]} className="inline-flex items-center justify-center gap-1.5 w-full md:w-auto bg-[#eab308] hover:bg-[#ca8a04] text-black font-black text-base md:text-lg py-2.5 px-6 md:py-3 md:px-10 rounded-xl shadow-[0_0_20px_rgba(234,179,8,0.3)] transform hover:scale-[1.02] transition-all duration-200 uppercase" data-id="element-38">
          👉 Sí, quiero mi pack →
        </a>
        <p className="text-gray-400 text-[10px] md:text-xs font-bold mt-2 flex items-center justify-center gap-1 uppercase tracking-wider" data-id="element-39">
          <Lock className="w-3 h-3 text-[#eab308]" data-id="element-40" /> PAGO SEGURO CON MERCADO
          PAGO
        </p>
      </div>
    </div>;
}